// ── THIS TAB'S SOCKET ID ────────────────────────────────────────────────────
// Pusher's `socket_id`, spelled for ActionCable (which has none): the tab sends
// it on every tenant API call (X-Socket-Id), the server tags the live update
// that call causes with it, and the org channel drops updates carrying it — a
// tab never hears its own write echo back ~2 s later, because it already
// refetched the moment the write returned. Other tabs of the same person still
// hear it; a job's change (no request, no socket) reaches every tab.
//
// One per page load / app launch, so it survives the cable re-keying on every
// token refresh. `getRandomValues`, not `randomUUID`: the latter needs a secure
// context and this also runs inside the native shell.
// ⚠ The server accepts exactly this shape (32 hex chars) and drops anything else.
const bytes = new Uint8Array(16)
crypto.getRandomValues(bytes)

export const SOCKET_ID = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('')
